/* This file is autogenerated, see readme.md for instructions */
import ParagraphLeftAlignSvgIcon from '@bloomreach/banana-theme/icons/paragraph-left-align.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ParagraphLeftAlignIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ParagraphLeftAlignSvgIcon />
    </Icon>
  );
});

ParagraphLeftAlignIcon.displayName = 'ParagraphLeftAlignIcon';

export default ParagraphLeftAlignIcon;
